import { ClockIcon, StethoscopeIcon } from '@quickmd-llc/design-system';

type TagProps = { text: string };

export default function Tag({ text }: TagProps) {
  const type = text.includes('Soonest') ? 'soonest' : 'lastVisit';
  return (
    <div className="flex h-auto w-fit items-center gap-2 rounded-full bg-coastal-blue-20 px-2 py-1 text-gray-700">
      {type === 'soonest' ? <ClockIcon iconSize="s" /> : <StethoscopeIcon />}
      <span className="text-xs font-semibold">{text}</span>
    </div>
  );
}
